import {SpotfightEvent} from './models';

export type LongTermEventStatus = 'open' | 'running' | 'finished';

export function longTermEventStatus(
  event: SpotfightEvent,
  now: Date = new Date()
): LongTermEventStatus {
  if (event.closed) {
    return 'finished';
  }

  return new Date(event.deadline).getTime() < now.getTime() ? 'running' : 'open';
}
